import get from 'lodash/get'
import deserialize from 'app/utils/deserialize'
import FormErrors from 'app/utils/form_errors'
import { fetch, create, update, remove } from 'app/utils/data'

function getTokensByType(list, type) {
  return list.filter((t) => t.type === type)
}

export default {
  namespaced: true,

  state: {
    list: [],
    npmToken: null,
    apiTokens: [],
    bandwidthUsed: null
  },

  recall: ['npmToken', 'apiTokens'],

  getters: {
    getTokensByType: (state) => (type) => getTokensByType(state.list, type),
    hasTokenType: (state) => (type) => getTokensByType(state.list, type).length > 0,
    npmToken: (state) => state.npmToken,
    apiTokens: (state) => state.apiTokens,
    bandwidthUsed: (state) => state.bandwidthUsed
  },

  mutations: {
    tokensFetched(state, { tokens }) {
      state.list = tokens
      state.npmToken = get(getTokensByType(tokens, 'npm'), [0], null)
      state.apiTokens = getTokensByType(tokens, 'api')
    },

    bandwidthUsageFetched(state, data) {
      state.bandwidthUsed = data
    },

    apiTokenDeleted(state, { id }) {
      state.apiTokens = state.apiTokens.filter((t) => t.id !== id)
    },

    resetState(state) {
      state.list = []
      state.npmToken = null
      state.apiTokens = []
      state.bandwidthUsed = null
    }
  },

  actions: {
    async fetchTokens({ commit }) {
      const response = await fetch({ url: '/api/tokens' })

      const tokens = await deserialize(response.data)

      commit('tokensFetched', { tokens })

      return tokens
    },

    async fetchTokenUsage({ commit }) {
      const response = await fetch({ url: '/api/token-usage' })

      const tokenUsage = await deserialize(response.data)

      commit('bandwidthUsageFetched', tokenUsage)

      return tokenUsage
    },

    async createAPIToken({ commit, dispatch }, data) {
      try {
        await create({
          url: '/api/tokens',
          data
        })

        await dispatch('fetchTokens')
      } catch (error) {
        if (get(error, ['response', 'data', 'errors'], null)) {
          throw new FormErrors(error.response.data.errors)
        } else {
          throw new FormErrors([{ detail: 'Darn. We rolled a 1 on that check.' }])
        }
      }
    },

    async regenerateToken({ commit, dispatch }, { token }) {
      try {
        const newToken = { ...token }

        newToken.token = null

        await update({
          url: `/api/tokens/${token.id}`,
          record: newToken
        })

        await dispatch('fetchTokens')
      } catch (error) {
        if (get(error, ['response', 'data', 'errors'], null)) {
          throw new FormErrors(error.response.data.errors)
        } else {
          throw new FormErrors([{ detail: 'Well this is embarrasing. Something went wrong.' }])
        }
      }
    },

    async deleteAPIToken({ commit }, id) {
      try {
        await remove({
          url: `/api/tokens/${id}`,
          type: 'token'
        })

        commit('apiTokenDeleted', { id })
      } catch (error) {
        throw new FormErrors([{ detail: 'Well this is embarrasing. Something went wrong.' }])
      }
    }
  }
}
